const nl = {
    nav: {
      home: "Home",
      browse: "Bruiloften ontdekken",
      dashboard: "Dashboard",
      messages: "Berichten",
      profile: "Profiel",
      login: "Inloggen",
      register: "Registreren",
      logout: "Uitloggen",
      admin: "Admin",
      faq: "FAQ",
      about: "Over ons",
      contact: "Contact",
      pricing: "Prijzen",
      howItWorks: "Hoe het werkt",
    },
    auth: {
      login: {
        title: "Welkom terug",
        email: "E-mail",
        password: "Wachtwoord",
        button: "Inloggen",
        noAccount: "Nog geen account?",
        register: "Registreer nu",
      },
      register: {
        title: "Account aanmaken",
        name: "Volledige naam",
        email: "E-mail",
        password: "Wachtwoord",
        role: "Ik wil...",
        roleHost: "Een bruiloft organiseren",
        roleGuest: "Bruiloften bijwonen",
        terms: "Ik accepteer de voorwaarden en privacybeleid",
        button: "Registreren",
        hasAccount: "Al geregistreerd?",
        login: "Log nu in",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Laden...",
      error: "Er is een fout opgetreden",
      success: "Succes",
      save: "Opslaan",
      cancel: "Annuleren",
      delete: "Verwijderen",
      edit: "Bewerken",
      back: "Terug",
      next: "Volgende",
      language: "Taal",
      currency: "Valuta",
      search: "Zoeken",
      filter: "Filteren",
      all: "Alle",
      none: "Geen",
      yes: "Ja",
      no: "Nee",
    },
    footer: {
      about: "Over ons",
      privacy: "Privacy",
      terms: "Voorwaarden",
      contact: "Contact",
      copyright: "© 2024 WEDVAYA. Alle rechten voorbehouden.",
    },
  };

export default nl;
